import { FC, ReactNode, useEffect, useState } from 'react';

import cs from 'classnames';

import styles from './Section.module.scss';

export type SectionBackgroundPictureName = 'wave';

interface SectionProps {
  children: ReactNode;
  background?: string;
  className?: string;
  id?: string;
  backgroundPictureName?: SectionBackgroundPictureName;
}

const Section: FC<SectionProps> = ({
  children,
  background,
  className,
  id,
  backgroundPictureName
}) => {
  const [bgColor, setBgColor] = useState<string | null>(null);

  useEffect(() => {
    if (background && background.startsWith('--')) {
      const rootStyle = getComputedStyle(document.documentElement);
      setBgColor(rootStyle.getPropertyValue(background).trim());
    }
  }, [background]);

  return (
    <section
      id={id || undefined}
      className={cs(
        styles.container,
        {
          [styles.withBg]: bgColor,
          [styles.wave]: backgroundPictureName === 'wave'
        },
        className
      )}
      style={{ color: bgColor || 'inherit' }}
    >
      {children}
    </section>
  );
};

export default Section;
